// FontAwesome icons

// Use plugins to only use the features we need
// Old import: import { config, dom, library } from 'Vendor/@fortawesome/fontawesome-svg-core'
// Docs: https://fontawesome.com/docs/apis/javascript/plugins
import {
	InjectCSS,
	Layers,
	// LayersCounter,
	// LayersText,
	// Masks,
	MutationObserver,
	PowerTransforms,
	register,
	ReplaceElements,
} from 'Vendor/@fortawesome/fontawesome-svg-core/plugins.mjs';

const api = register([
	InjectCSS,
	Layers,
	// LayersCounter,
	// LayersText,
	// Masks,
	MutationObserver,
	PowerTransforms,
	ReplaceElements,
])

api.config.autoReplaceSvg = 'nest';
api.config.observeMutations = true;

// Solid icons
import { faAngleLeft      } from 'Vendor/@fortawesome/free-solid-svg-icons/faAngleLeft';
import { faAngleRight     } from 'Vendor/@fortawesome/free-solid-svg-icons/faAngleRight';
import { faBars           } from 'Vendor/@fortawesome/free-solid-svg-icons/faBars';
import { faBasketShopping } from 'Vendor/@fortawesome/free-solid-svg-icons/faBasketShopping';
import { faCheck          } from 'Vendor/@fortawesome/free-solid-svg-icons/faCheck';
import { faCircle         } from 'Vendor/@fortawesome/free-solid-svg-icons/faCircle';
import { faCircleQuestion } from 'Vendor/@fortawesome/free-solid-svg-icons/faCircleQuestion';
import { faPencil         } from 'Vendor/@fortawesome/free-solid-svg-icons/faPencil';
import { faPiggyBank      } from 'Vendor/@fortawesome/free-solid-svg-icons/faPiggyBank';
import { faQuoteLeft      } from 'Vendor/@fortawesome/free-solid-svg-icons/faQuoteLeft';
import { faQuoteRight     } from 'Vendor/@fortawesome/free-solid-svg-icons/faQuoteRight';
import { faXmark          } from 'Vendor/@fortawesome/free-solid-svg-icons/faXmark';

api.library.add({
	faAngleLeft,
	faAngleRight,
	faBars,
	faBasketShopping,
	faCheck,
	faCircle,
	faCircleQuestion,
	faPencil,
	faPiggyBank,
	faQuoteLeft,
	faQuoteRight,
	faXmark,
})

// Replace and watch
api.dom.i2svg();
api.dom.watch();